import React from 'react';
import { Route } from 'react-router-dom';
import StudentsDocuments from '@/pages/transcripts/StudentsDocuments';
import StaffDocuments from '@/pages/transcripts/StaffDocuments';
import ConsultantDocuments from '@/pages/transcripts/ConsultantsDocuments';
import SuppliersDocuments from '@/pages/transcripts/SuppliersDocuments';
import Registration from '@/pages/transcripts/Registration';
import Admit from '@/pages/transcripts/Admit';
import Marksheet from '@/pages/transcripts/Marksheet';
import Certificate from '@/pages/transcripts/Certificate';
import Migration from '@/pages/transcripts/Migration';
import UploadRegistration from '@/pages/transcripts/UploadRegistration';
import UploadAdmit from '@/pages/transcripts/UploadAdmit';
import UploadMarksheet from '@/pages/transcripts/UploadMarksheet';
import UploadCertificate from '@/pages/transcripts/UploadCertificate';
import UploadMigration from '@/pages/transcripts/UploadMigration';

export const transcriptsRoutes = (
  <React.Fragment>
    <Route path="transcripts/students-documents" element={<StudentsDocuments />} />
    <Route path="transcripts/staff-documents" element={<StaffDocuments />} />
    <Route path="transcripts/consultant-documents" element={<ConsultantDocuments />} />
    <Route path="transcripts/suppliers-documents" element={<SuppliersDocuments />} />
    <Route path="transcripts/registration" element={<Registration />} />
    <Route path="transcripts/admit" element={<Admit />} />
    <Route path="transcripts/marksheet" element={<Marksheet />} />
    <Route path="transcripts/certificate" element={<Certificate />} />
    <Route path="transcripts/migration" element={<Migration />} />
    <Route path="transcripts/upload-registration" element={<UploadRegistration />} />
    <Route path="transcripts/upload-admit" element={<UploadAdmit />} />
    <Route path="transcripts/upload-marksheet" element={<UploadMarksheet />} />
    <Route path="transcripts/upload-certificate" element={<UploadCertificate />} />
    <Route path="transcripts/upload-migration" element={<UploadMigration />} />
  </React.Fragment>
);
